var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 0.754993C28.3722 0.741825 28.2434 0.741825 28.1157 0.754993H1.86565C1.69741 0.757585 1.53028 0.782812 1.36877 0.829993L14.9156 14.3206L28.5 0.754993Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8875 2.05811L16.2375 15.6519C15.8862 16.0011 15.411 16.1971 14.9156 16.1971C14.4203 16.1971 13.9451 16.0011 13.5938 15.6519L0.065625 2.16123C0.024037 2.31408 0.00198627 2.47159 0 2.62998V21.38C0 21.8773 0.197544 22.3542 0.549175 22.7058C0.900806 23.0574 1.37772 23.255 1.875 23.255H28.125C28.6223 23.255 29.0992 23.0574 29.4508 22.7058C29.8025 22.3542 30 21.8773 30 21.38V2.62998C29.9925 2.43466 29.9546 2.2417 29.8875 2.05811V2.05811ZM3.15938 21.38H1.85625V20.0394L8.67188 13.28L9.99375 14.6019L3.15938 21.38ZM28.1062 21.38H26.7937L19.9594 14.6019L21.2812 13.28L28.0969 20.0394L28.1062 21.38Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailImage);
export default __webpack_public_path__ + "static/media/mailImage.33be21b3a0ea77318895f1c16c0a9c25.svg";
export { ForwardRef as ReactComponent };